<template>
  <div>
    <vx-card v-if="orgData && orgData._id" class="org-card">
      <vs-tabs
        :position="isSmallerScreen ? 'top' : 'left'"
        class="tabs-shadow-none"
        id="profile-tabs"
        :key="isSmallerScreen"
      >
        <vs-tab
          icon-pack="feather"
          icon="icon-user"
          :label="!isSmallerScreen ? 'Account' : ''"
        >
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-account />
          </div>
        </vs-tab>
        <!-- <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'API' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <org-settings-developer />
            </div>
          </vs-tab> -->
        <vs-tab
          icon-pack="feather"
          icon="icon-box"
          :label="!isSmallerScreen ? 'Configuration' : ''"
        >
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-config />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import OrgSettingsAccount from "./OrgSettingsAccount.vue";
import OrgSettingsPlatformPreferences from "./OrgSettingsPlatformPreferences.vue";
import OrgSettingsApps from "./OrgSettingsApps.vue";
import OrgSettingsResumeSettings from "./OrgSettingsResumeSettings.vue";
import OrgSettingsAdmins from "./OrgSettingsAdmins.vue";
import OrgSettingsHelp from "./OrgSettingsHelp.vue";
import OrgSettingsDeveloper from "./OrgSettingsDeveloper.vue";
import OrgSettingsFunds from "./OrgSettingsFunds.vue";
import OrgSettingsConfig from "./OrgSettingsConfig.vue";

export default {
  components: {
    OrgSettingsAccount,
    OrgSettingsPlatformPreferences,
    OrgSettingsApps,
    OrgSettingsResumeSettings,
    OrgSettingsAdmins,
    OrgSettingsHelp,
    OrgSettingsDeveloper,
    OrgSettingsFunds,
    OrgSettingsConfig,
  },
  data() {
    return {
      // isSubAdmin: { checked: false, value: undefined }
    };
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    isSubAdmin() {
      if (!(this.orgData && this.orgData._id)) return true;
      else if (
        this.orgData.subAdmins &&
        this.orgData.subAdmins.findIndex(
          (sa) => sa.email === this.userData.email
        ) != -1
      )
        return true;
      return false;
    },
  },
  watch: {
    orgData(newVal) {
      // console.log(newVal);
      if (newVal) {
        // this.checkIfSubAdmin();
      }
    },
  },
  methods: {
    checkIfSubAdmin() {
      const orgObj = {
        email: this.userData.email,
        organizationId: this.orgData._id,
      };
      // console.log(orgObj);
      this.$store
        .dispatch("organization/fetchSubAdminByEmailOrgId", orgObj)
        .then((res) => {
          // console.log(res.data);
          if (res.data.total > 0) {
            this.isSubAdmin.value = true;
          } else {
            this.isSubAdmin.value = false;
          }
          this.isSubAdmin.checked = true;
          this.$forceUpdate();
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
